const styles = (theme) => ({
    root: {},
    title: {
        color: 'white',
        paddingBottom: 15,
    },
});

export default styles;
